// Module
var code = "<h2 id=\"repaying-your-loans\">Repaying Your Loans</h2> <p>Convenient, flexible options make it easy to pay back your student loan.</p> ";
// Exports
export default code;